import script from "./TempCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./TempCarousel.vue?vue&type=script&setup=true&lang=js"

import "./TempCarousel.vue?vue&type=style&index=0&id=6fe701d2&scope=true&lang=css"
import "bootstrap/dist/css/bootstrap.css?vue&type=style&index=1&id=6fe701d2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe701d2"]])

export default __exports__